const blinkingCursorStyle = {
  display: 'inline-block',
  width: 2,
  height: '1em',
  backgroundColor: 'var(--mantine-color-cyan-4)',
  marginLeft: 2,
  verticalAlign: 'text-bottom',
  animation: 'beatCursorBlink 0.8s step-end infinite',
}

const blinkKeyframes = `
  @keyframes beatCursorBlink {
    0%, 100% { opacity: 1; }
    50% { opacity: 0; }
  }
`

export function StreamingCursor() {
  return (
    <>
      <span style={blinkingCursorStyle} />
      <style>{blinkKeyframes}</style>
    </>
  )
}
